export var TAB_SIZE;
(function (TAB_SIZE) {
    TAB_SIZE[TAB_SIZE["MINI"] = 0] = "MINI";
    TAB_SIZE[TAB_SIZE["SMALL"] = 1] = "SMALL";
    TAB_SIZE[TAB_SIZE["NORMAIL"] = 2] = "NORMAIL";
})(TAB_SIZE || (TAB_SIZE = {}));
const MAX_ITERATION = 300;
class LevelQueue {
    constructor(arr = []) {
        this.iterationCount = 0;
        this.map = new Map();
        arr.forEach(key => {
            this.map.set(key, []);
        });
    }
    insert(data) {
        try {
            data.forEach(item => {
                const { size } = item;
                if (this.map.has(size)) {
                    const arr = this.map.get(size);
                    if (Array.isArray(arr)) {
                        arr.push(item);
                    }
                }
            });
        }
        catch (error) {
            console.error('[LevelQueue] insert error', error);
        }
    }
    update(data) {
        try {
            this.map.forEach(arr => {
                arr.length = 0;
            });
            this.insert(data);
        }
        catch (error) {
            console.error('[LevelQueue] update error', error);
        }
    }
    getMinValue() {
        var _a;
        let minSize = Infinity;
        this.map.forEach((arr, size) => {
            if (arr.length && size < minSize) {
                minSize = size;
            }
        });
        let arr = [];
        if ((_a = this.map.get(minSize + 1)) === null || _a === void 0 ? void 0 : _a.length) {
            arr = this.map.get(minSize + 1) || [];
        }
        else {
            arr = this.map.get(minSize) || [];
        }
        if (Array.isArray(arr) && arr.length > 0) {
            let maxLevel = 0;
            arr.forEach(item => {
                if (item.level > maxLevel) {
                    maxLevel = item.level;
                }
            });
            const targetArr = arr.filter(item => item.level === maxLevel);
            const target = targetArr.reduce((prev, current) => {
                return prev.index > current.index ? prev : current;
            });
            return target;
        }
    }
    getMaxValue() {
        var _a;
        let minSize = Infinity;
        this.map.forEach((arr, sizeKey) => {
            if (arr.length && sizeKey < minSize) {
                minSize = sizeKey;
            }
        });
        let arr = [];
        if ((_a = this.map.get(minSize)) === null || _a === void 0 ? void 0 : _a.length) {
            arr = this.map.get(minSize) || [];
        }
        else {
            arr = this.map.get(minSize + 1) || [];
        }
        if (Array.isArray(arr) && arr.length > 0) {
            let minLevel = +Infinity;
            arr.forEach(item => {
                if (item.level < minLevel) {
                    minLevel = item.level;
                }
            });
            const targetArr = arr.filter(item => item.level === minLevel);
            const target = targetArr.reduce((prev, current) => {
                return prev.index < current.index ? prev : current;
            });
            return target;
        }
    }
    insertByLevel(arg) {
        const arr = this.map.get(arg.size);
        if (arr) {
            arr.push(arg);
        }
    }
    getPrevLevel(level) {
        return level - 1 >= TAB_SIZE.MINI ? level - 1 : TAB_SIZE.MINI;
    }
    getNextLevel(level) {
        return level + 1 <= TAB_SIZE.NORMAIL ? level + 1 : TAB_SIZE.NORMAIL;
    }
    downgrade(arg) {
        try {
            const arr = this.map.get(arg.size);
            arr === null || arr === void 0 ? void 0 : arr.splice(arr.findIndex(item => item.key === arg.key), 1);
            arg.size = this.getPrevLevel(arg.size);
            this.insertByLevel(arg);
        }
        catch (error) {
            console.error('[LevelQueue] downgrade error', error);
        }
    }
    upgrade(arg) {
        try {
            const arr = this.map.get(arg.size);
            arr === null || arr === void 0 ? void 0 : arr.splice(arr.findIndex(item => item.key === arg.key), 1);
            arg.size = this.getNextLevel(arg.size);
            this.insertByLevel(arg);
        }
        catch (error) {
            console.error('[LevelQueue] upgrade error', error);
        }
    }
    getTotalWidth() {
        let totalWidth = 0;
        try {
            this.map.forEach(arr => {
                arr.forEach(item => {
                    totalWidth += item.size2widthMap[item.size] || 0;
                });
            });
        }
        catch (error) {
            console.error('[LevelQueue] getTotalWidth error', error);
        }
        return totalWidth;
    }
    getEstimateTotalWidth(key, width) {
        let totalWidth = 0;
        try {
            this.map.forEach(arr => {
                arr.forEach(item => {
                    if (item.key === key) {
                        totalWidth += width;
                    }
                    else {
                        totalWidth += item.size2widthMap[item.size] || 0;
                    }
                });
            });
        }
        catch (error) {
            console.error('[LevelQueue] getEstimateTotalWidth error', error);
        }
        return totalWidth;
    }
    getChabuduodeState(wrapWidth, canResetCount = true) {
        this.iterationCount++;
        if (this.iterationCount > MAX_ITERATION) {
            return;
        }
        try {
            let totalWidth = this.getTotalWidth();
            const isOverFlow = totalWidth > wrapWidth;
            if (isOverFlow) {
                const min = this.getMinValue();
                if (min && min.key != null) {
                    if ((min === null || min === void 0 ? void 0 : min.size) > TAB_SIZE.MINI) {
                        this.downgrade(min);
                        this.getChabuduodeState(wrapWidth, false);
                    }
                }
            }
            else {
                const max = this.getMaxValue();
                if (max && max.key != null) {
                    if ((max === null || max === void 0 ? void 0 : max.size) < TAB_SIZE.NORMAIL) {
                        const tempTotalWidth = this.getEstimateTotalWidth(max.key, max.size2widthMap[this.getNextLevel(max.size)]);
                        if (tempTotalWidth < wrapWidth) {
                            this.upgrade(max);
                            this.getChabuduodeState(wrapWidth, false);
                        }
                    }
                }
            }
        }
        catch (error) {
            console.error('[LevelQueue] getChabuduodeState error', error);
        }
        if (canResetCount) {
            this.iterationCount = 0;
        }
    }
    getFinalState() {
        const result = [];
        try {
            this.map.forEach(arr => {
                arr.forEach(item => {
                    result.push(Object.assign(Object.assign({}, item), { size: item.size }));
                });
            });
        }
        catch (error) {
            console.error('[LevelQueue] getFinalState error', error);
        }
        return result;
    }
}
export default LevelQueue;
